export const legend_style = {
    backgroundColor: '#fff',
    borderRadius: '3px',
    bottom: '30px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
    font: "12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif",
    padding: "10px",
    position: "absolute",
    right: "10px",
    zIndex: 1
}
export const legend_style_left = {
    backgroundColor: '#fff',
    borderRadius: '3px',
    bottom: '30px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
    font: "12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif",
    padding: "10px",
    position: "absolute",
    left: "10px",
    zIndex: 1
}

export const legend_style_middle = {
    backgroundColor: '#fff',
    borderRadius: '3px',
    bottom: '30px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
    font: "12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif",
    padding: "10px",
    position: "absolute",
    zIndex: 1,
    marginRight: "35%",
    marginLeft: "35%",
    textAlign:"center"
}

export const legend_h4_style = {
    margin: "0 0 10px"
}

export const legend_div_span_style = {
    borderRadius: "50%",
    display: "inline-block",
    height: "10px",
    marginRight: "5px",
    width: "10px"
}